import {
  Box,
  Typography
} from '@mui/material';
import { useAuthStateQuery } from 'generated/graphql';
import { CustomIcons } from 'modules';
import {
  Navigate,
  Outlet
} from 'react-router-dom';
import loginBackgroundImage from '../../assets/loginArt/Onboarding/image 77.png';



export type AuthLayoutProps = {};
/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const AuthLayout = (props: AuthLayoutProps) => {
  const queryTuple = useAuthStateQuery();

  if (queryTuple.data?.authStatus === 'signedIn') {
    return <Navigate to='/insights' />;
  }

  return (
    <Box
      display='flex'
      flexDirection='row'
      padding='2.5rem'
      height='100vh'
      justifyContent='space-around'
    >
      <Box>
        <Outlet />
      </Box>

      <Box
        display='flex'
        flexDirection='column'
        paddingY='6.5rem'
        alignItems='center'
      >

        <CustomIcons.LargeIcon.FC
          icon='COMPANYLOGIN'
        />
        <Box
          component='img'
          src={loginBackgroundImage}
        />
        <Box
          maxWidth='33.5rem'
          display='flex'
          flexDirection='column'
          paddingBottom='3rem'
        >

          <Typography
            textAlign='center'
            variant='loginSectionTitle'
          >
            Mastermind for Financial Research
          </Typography>
          <Typography
            textAlign='center'
            variant='loginSectionSubTitle'
          >
            Built for institutional research firms and investment professionals, easy enough for the every day investor.
          </Typography>
        </Box>
      </Box>

    </Box>

  );
};
